export enum BannerCode {
  Izanavi = 'IZANAVI',
  // Platinum = 'Platinum',
  Anime = 'Anime',
  DiscountPrimeSub = 'DiscountPrimeSub',
  DiscountMembership = 'DiscountMembership',
  TakatradeOpening = 'TakatradeOpening',
  Event = 'Event',
}
